import { ReactElement } from 'react'

import { Color } from '../../enums/color'
import { LocaleIdentifier } from '../../types/localeIdentifier'
import { TextVariant } from '../Text'
import { useScaleFontSizes } from './hooks/useScaleFontSizes'
import * as Styled from './styles'
import { getFormattedValue } from './utils/getFormattedValue'

export interface AmountValueProps {
  alignCenter?: boolean
  amount: number
  currencyId?: string
  color?: Color
  locale: LocaleIdentifier
  shortFormat?: boolean
  textVariant?: TextVariant
  withScaling?: boolean
}

export const AmountValue = ({
  alignCenter = false,
  amount,
  currencyId,
  color,
  locale,
  shortFormat,
  textVariant = 'h2',
  withScaling = true,
  ...rest
}: AmountValueProps): ReactElement => {
  const { valueFontSize, currencyFontSize, containerRef, valueRef, currencyRef } = useScaleFontSizes(withScaling)
  const { decimalPart, decimalSeparator, integerPart } = getFormattedValue(amount, locale, shortFormat)
  const shouldShowDecimalValue = shortFormat === false || (shortFormat === undefined && decimalPart !== '00')

  return (
    <Styled.AmountValueWrapper {...rest} ref={containerRef} alignCenter={alignCenter} data-testid="amountValue">
      <Styled.ScaledText color={color || Color.Black} variant={textVariant} ref={valueRef} fontSize={valueFontSize}>
        {integerPart}
      </Styled.ScaledText>

      {(shouldShowDecimalValue || currencyId) && (
        <Styled.ScaledText
          alignment="center"
          color={color || Color.Grey700}
          fontSize={currencyFontSize}
          ref={currencyRef}
          variant="bodyMD"
          weight="regular"
        >
          {shouldShowDecimalValue && `${decimalSeparator}${decimalPart}`}
          {currencyId && <Styled.CurrencyText>{currencyId}</Styled.CurrencyText>}
        </Styled.ScaledText>
      )}
    </Styled.AmountValueWrapper>
  )
}
